import React from 'react'

const JuniorDivision = () => {
    return (
        <>

            <section className="section-sp1 mid-light">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h2 className='text-center'>NTSE / OLYMPIADS</h2>
                            <p style={{ textAlign: "justify", lineHeight: 2 }}>Reliable Institute believes in imparting joyful, relevant, and value based education to each child and ensures complete fulfilment of the aspirations of all stakeholders. We are the team of expert faculty pool with more than 15 years of academic excellence. Reliable Institute aims at nurturing young minds and preparing them for various competitive exams like NTSE | IJSO | PRMO | NCERT | SCIENCE/MATHS/ENGLISH OLYMPIADS and board exams.</p>
                            <div className="row justify-content-center">
                                <div className="col-lg-4 pt-4">
                                    <div className="services-bx">
                                        <h4 className='text-center'>Premium Course</h4>
                                        <button type="button" className="btn btn-outline-danger btn-md">
                                            <a href="https://reliablekota.com/junior-division-courses/classwise-list/" style={{ textDecoration: "none" }}>
                                                View Details
                                            </a>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-lg-4 pt-4">
                                    <div className="services-bx">
                                        <h4 className='text-center'>Regular Course</h4>
                                        <button type="button" className="btn btn-outline-danger btn-md">
                                            <a href="https://reliablekota.com/junior-division-courses/classwise-list/" style={{ textDecoration: "none" }}>
                                                View Details
                                            </a>
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default JuniorDivision